import React, { useState } from 'react';
import { useForm } from 'react-hook-form';

// components
import { FormGroup, Input, Row, Col, Button } from "reactstrap";

// helpers
import { showMessage } from "../../../helpers/message";

// api
import analiseboletim_api from "../../../api/analiseboletim_api.js";

export default function AnaliseInconformidades({ boletimVistoria, setshowLoading, handleReturn }) {

    const { register, getValues } = useForm({ mode: "onBlur" });

    const [anexo, set_anexo] = useState([]);
    const handleChangeAnexo = (event) => {
        event.preventDefault();
        if (event.target.files.length) {
            const file = event.target.files[0];
            const fsize = Math.round((file.size / 1024));

            if (fsize == 0) {
                showMessage("Aviso", "Arquivo selecionado inválido. Tamanho do aquivo: " + fsize + "MB", 'error', null);
                return;
            }

            if (file.type != "image/png" && file.type != "image/jpeg" && file.type != "application/pdf") {
                showMessage("Aviso", "Formato do arquivo " + file.type + " inválido. O arquivo deve estar nos formatos: png/jpeg/pdf.", 'error', null);
                return;
            }

            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onloadend = function () {
                var base64data = reader.result;
                set_anexo([
                    {
                        base64: base64data.replace("data:image/png;base64,", "").replace("data:image/jpeg;base64,", "").replace("data:application/pdf;base64,", ""),
                        tipoAnexo: "Defesa"
                    }
                ]);
            }
        }
    }

    const handleExecutarAcao = (acao) => {
        let data = getValues();

        let json_submit = {
            boletimVistoria_Id: boletimVistoria.boletimVistoria_Id,
            situacaoAnalise: boletimVistoria.situacaoAnalise,
            acao: acao,
            observacao: data.observacao,
            anexos: anexo
        }

        setshowLoading(true);
        analiseboletim_api.post(json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Operação executada com sucesso!", 'success', function () { handleReturn(true) });
            }
        })
    }

    return (
        <>
            <h5 className="subtitleCardInfo">Análise de Inconformidades</h5>
            <Row className="mb-4">
                <Col lg="12" md="12" sm="12">
                    <FormGroup>
                        <label className="form-control-label">Observações</label>
                        <Input className="form-control"
                            autocomplete="off"
                            type="text"
                            name="observacao"
                            innerRef={register({ required: false })}
                        />
                    </FormGroup>
                </Col>
                <Col lg="12" md="12" sm="12">
                    <FormGroup>
                        <label className="form-control-label">Anexar Arquivo</label>
                        <Input className="form-control"
                            autocomplete="off"
                            type="file"
                            onChange={(event) => handleChangeAnexo(event)}
                        />
                    </FormGroup>
                </Col>
                <Col lg="12" md="12" sm="12">
                    <Button color="success" onClick={() => handleExecutarAcao("Aprovar Boletim")}>
                        Aprovar
                    </Button>
                    <Button color="danger" onClick={() => handleExecutarAcao("Reprovar Boletim")}>
                        Reprovar
                    </Button>
                </Col>
            </Row>
        </>
    );
}
